import whenDomReady from "when-dom-ready";
import { initPage } from "../pages/base/browser_extension_modal";

whenDomReady()
  .then(() => {
    setTimeout(() => {
      initPage();
    }, 1000);
  })
  .catch((error) => {
    console.error("Error initializing:", error);
  });
